export default "__VITE_ASSET__CBdp6szq__"